import { DocumentMagnifyingGlassIcon } from "@heroicons/react/20/solid";

export const ErgonomicsNeedZoom = () => {
  return (
    <div className="h-full text-perception-gray-700 flex flex-col justify-center items-center gap-4 text-center">
      <DocumentMagnifyingGlassIcon aria-hidden="true" className="size-16" />
      Sélectionnez une période temporelle à observer pour faire apparaître les détails.
    </div>
  );
};